import React, { useContext } from "react";
import { Box, Grid } from "@mui/material";
import Typography from "@mui/material/Typography";
import PageButton from "../../components/PageButton";
import style from "./Explore_2_3.module.css";
import SingleChoiceBtnGroup from "../../components/button_group/SingleChoiceBtnGroup";
import PieChart from "../../components/explore/Explore_2_3_img";
import { observer } from "mobx-react-lite";
import { RootStoreContext } from "../../store";

function Explore_2_3() {
  const { ExploreStore } = useContext(RootStoreContext);
  const { role } = ExploreStore;
  return (
    <Box className={style.box}>
      <Grid xs={12} container justifyContent="center" alignItems="center">
        <Grid item xs={12} md={6} className={style.questionbox}>
          <div>
            <Typography variant="h4">創業能力養成來自哪裡?</Typography>
          </div>
          <div className={style.line}></div>
          <div className={style.Discription}>
            <Typography variant="h7">
              圖為根據〈2019台灣新創生態圈大調查〉，對於個人投入創業時已經具備的能力進行調查。
            </Typography>
          </div>
          <div className={style.TitleBox}>
            <Typography variant="h7" className={style.Title}>
              我目前的身份為：
            </Typography>
            <Typography variant="h7" className={style.SubTitle}>
              &nbsp;(請選擇)
            </Typography>
            <Typography variant="h7" className={style.SubTitle}>
              {role}
            </Typography>
          </div>
          <div className={style.ChoiceBtn}>
            <SingleChoiceBtnGroup
              btntext1="學生"
              btntext2="上班族"
              btntext3="公司負責人"
              btntext4="待業中"
            />
          </div>
        </Grid>
        <Grid item xs={12} md={6}>
          <div>
            <PieChart />
          </div>
        </Grid>
      </Grid>
      <div className={style.pageBtn}>
        <PageButton passPath={"/explore-4"} nextPath={"/explore-3-1"} />
      </div>
    </Box>
  );
}

export default observer(Explore_2_3);
